var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPillColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2486_207312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 54,
    height: 54,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2486_207312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.575 34.8688L43.5375 28.85C44.7375 27.65 45.6562 26.2812 46.2938 24.7437C46.9313 23.2063 47.25 21.5938 47.25 19.9062C47.25 16.3812 46.0219 13.3906 43.5656 10.9344C41.1094 8.47813 38.1187 7.25 34.5938 7.25C32.9062 7.25 31.2938 7.56875 29.7563 8.20625C28.2188 8.84375 26.85 9.7625 25.65 10.9625L19.6312 16.925L37.575 34.8688ZM19.4062 47.75C21.0938 47.75 22.7063 47.4313 24.2437 46.7938C25.7812 46.1562 27.15 45.2375 28.35 44.0375L34.3688 38.075L16.425 20.1312L10.4625 26.15C9.2625 27.35 8.34375 28.7188 7.70625 30.2563C7.06875 31.7938 6.75 33.4062 6.75 35.0938C6.75 38.6187 7.97813 41.6094 10.4344 44.0656C12.8906 46.5219 15.8812 47.75 19.4062 47.75Z",
    fill: "#D1E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5375 28.85L37.575 34.8688L19.6312 16.925L25.65 10.9625C26.85 9.7625 28.2188 8.84375 29.7563 8.20625C31.2938 7.56875 32.9062 7.25 34.5938 7.25C38.1187 7.25 41.1094 8.47813 43.5656 10.9344C46.0219 13.3906 47.25 16.3812 47.25 19.9062C47.25 21.5938 46.9313 23.2063 46.2938 24.7437C45.6562 26.2812 44.7375 27.65 43.5375 28.85Z",
    fill: "#053692"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPillColor);
export default __webpack_public_path__ + "static/media/icon_pill_color.97a35b55f1b3f059516058e86be706a1.svg";
export { ForwardRef as ReactComponent };